export default {
      id: "logout-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#logout",
      toString: function () {
        return this.url;
      }
    }